import React from 'react';

require('./styles.pcss');

const K50BotInvisibleSeoTag = ({ isOutOfStock = false }) => (
  <div className="random_tag">{isOutOfStock ? 'Не в наличии' : 'В корзину'}</div>
);

export default K50BotInvisibleSeoTag;
